import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { X, GripVertical, ArrowDownUp } from "react-bootstrap-icons";
import CustomButton from "../../../../components/buttons/button";

const CarrosselOrderModal = ({ images, onClose, onSave, getImageUrl }) => {
	const [orderedImages, setOrderedImages] = useState([...images].sort((a, b) => a.ordem - b.ordem));
	const [draggedIndex, setDraggedIndex] = useState(null);
	const [dragOverIndex, setDragOverIndex] = useState(null);

	const handleDragStart = (e, index) => {
		setDraggedIndex(index);
		e.dataTransfer.effectAllowed = 'move';
	};

	const handleDragOver = (e, index) => {
		e.preventDefault();
		if (draggedIndex === null || draggedIndex === index) return;
		setDragOverIndex(index);
	};

	const handleDragLeave = () => {
		setDragOverIndex(null);
	};

	const handleDrop = (e, dropIndex) => {
		e.preventDefault();
		if (draggedIndex === null || draggedIndex === dropIndex) {
			setDraggedIndex(null);
			setDragOverIndex(null);
			return;
		}

		const newOrder = [...orderedImages];
		const [draggedItem] = newOrder.splice(draggedIndex, 1);
		newOrder.splice(dropIndex, 0, draggedItem);

		setOrderedImages(newOrder);
		setDraggedIndex(null);
		setDragOverIndex(null);
	};

	const handleDragEnd = () => {
		setDraggedIndex(null);
		setDragOverIndex(null);
	};

	const handleSave = () => {
		const newOrderData = orderedImages.map((img, index) => ({
			id: img.id,
			ordem: index + 1
		}));
		onSave(newOrderData);
	};

	return (
		<Modal show={true} onHide={onClose} size="md" centered className="carrossel-order-modal">
			<Modal.Header className="carrossel-order__header">
				<h2 className="carrossel-order__title">
					Ordenar carrossel
				</h2>
			</Modal.Header>
			<Modal.Body className="p-0">
				<div className="carrossel-order__wrapper">
					<div className="carrossel-order__list">
						{orderedImages.map((image, index) => (
							<div
								key={image.id}
								className={`carrossel-order__item ${draggedIndex === index ? 'dragging' : ''} ${dragOverIndex === index ? 'drag-over' : ''}`}
								draggable
								onDragStart={(e) => handleDragStart(e, index)}
								onDragOver={(e) => handleDragOver(e, index)}
								onDragLeave={handleDragLeave}
								onDrop={(e) => handleDrop(e, index)}
								onDragEnd={handleDragEnd}>
								<span className="carrossel-order__number">{index + 1}º</span>
								<div className="carrossel-order__grip">
									<GripVertical size={20}/>
								</div>
								<span className="carrossel-order__name">{image.nome}</span>
								<div className="carrossel-order__thumbnail">
									<img
										src={getImageUrl(image.id, 'thumbnail')}
										alt={image.nome}
									/>
								</div>
								<div className="carrossel-order__arrows">
									<ArrowDownUp size={16}/>
								</div>
							</div>
						))}
					</div>

				</div>
			</Modal.Body>
			<Modal.Footer className="carrossel-order__footer">
				<div className="carrossel-order__cancel-button">
					<CustomButton
						label="Cancelar"
						width="140px"
						blue_button={true}
						onClick={onClose}
						type="button"
						marginTop="0"
						id="carrossel-order-cancel-btn"
					/>
				</div>
				<div className="carrossel-order__save-button">
					<CustomButton
						onClick={handleSave}
						label="Salvar"
						id="carrossel-order-save-btn"
						width="140px"
						blue_button={true}
						type="button"
						marginTop="0"
					/>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default CarrosselOrderModal;